import React, { Fragment, useCallback } from 'react';
import animateScrollTo from 'animated-scroll-to';
import { aboutUs, newKeyWords, aboutJalaramBapa, aboutVirpurJalaram } from './Seo';

/**
 * Footer Component (Optimized)
 * - Converted from class to functional component
 * - Uses useCallback for scroll handler
 * - Cleaner, more readable code
 */
const Footer = () => {
    const scrollTo = useCallback((e, selector) => {
        e.preventDefault();
        animateScrollTo(document.querySelector(selector), { offset: -85 });
    }, []);

    return (
        <Fragment>
                <footer className="bg-dark">
                    <div className="container">
                        <div className={'row'} style={{ 'marginTop': '45px' }}>
                            <div className="col-sm-3 col-lg-3">
                                <div className="ftr_cnt">
                                    <h3>CONTACT US</h3>
                                    <ul>
                                        <li>
                                            <i className="fa fa-map-marker"></i>
                                            <p>Opp. Jalaram Atithi Gruh, Railway station Road, Virpur (Jalaram) - 360380
                                            </p>
                                        </li>
                                        <li>
                                            <i className="fa fa-phone"></i>
                                            <p className="footer-link"><a className="footer-content" href={'tel:+919925870037'}>+91 99258 70037</a></p>
                                        </li>
                                        <li>
                                            <i className="fa fa-envelope"></i>
                                            <p className="footer-link"><a className="footer-content" href={'mailto:info@hotelchitrakut.in'}>info@hotelchitrakut.in</a></p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-sm-3 col-lg-3">
                                <div className="ftr_cnt">
                                    <h3>SITE MAP</h3>
                                    <ul className="quick_link">
                                        <li>
                                            <p className="footer-link">
                                                <a className="footer-content" href="/" onClick={(e) => animateScrollTo(0)}>HOME</a>
                                            </p>
                                        </li>
                                        <li>
                                            <p className="footer-link">
                                                <a className="footer-content" href="/" onClick={(e) => scrollTo(e, '#aboutUs')}>ABOUT US</a>
                                            </p>
                                        </li>
                                        <li>
                                            <p className="footer-link">
                                                <a className="footer-content" href="/" onClick={(e) => scrollTo(e, '#rooms')}>ROOMS</a>
                                            </p>
                                        </li>
                                        <li>
                                            <p className="footer-link">
                                                <a className="footer-content" href="/" onClick={(e) => scrollTo(e, '#amenities')}>AMENITIES</a>
                                            </p>
                                        </li>
                                        <li>
                                            <p className="footer-link">
                                                <a className="footer-content" href="/" onClick={(e) => scrollTo(e, '#gallery')}>GALLERY</a>
                                            </p>
                                        </li>
                                        <li>
                                            <p className="footer-link">
                                                <a className="footer-content" href="/" onClick={(e) => scrollTo(e, '#attractions')}>ATTRACTIONS</a>
                                            </p>
                                        </li>
                                        <li>
                                            <p className="footer-link">
                                                <a className="footer-content" href="/" onClick={(e) => scrollTo(e, '#contactUs')}>CONTACT US</a>
                                            </p>
                                        </li>
                                    </ul>

                                </div>
                            </div>
                            <div className="col-sm-6 col-lg-6">
                                <div className="ftr_cnt">
                                    <h3>ABOUT US</h3>
                                    <p className={'footer-about-us'}>{aboutUs}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
                <section className={'bg-black copy-right'}>
                    <div className={'container'}>
                        <div className={'row'}>
                            <div className={'col-sm-12 col-lg-12'}>
                                <p className={'siteKeywords'}><strong>Who is The Saint Jalaram Bapa ?</strong><br />{aboutJalaramBapa} <a href={'https://en.wikipedia.org/wiki/Jalaram_Bapa'}>more...</a></p>
                                <p className={'siteKeywords'}><strong>What is Virpur Jalaram ?</strong><br />{aboutVirpurJalaram} <a href={'https://en.wikipedia.org/wiki/Virpur_(Rajkot)'}>more...</a></p>
                                <p className={'siteKeywords'}>{newKeyWords}</p>
                            </div>
                            <div className={'col-sm-12 col-lg-12 top-line'}>
                                <div className={'pull-left'}>
                                    <p>Hotel Chitrakut @ 1992 - {new Date().getFullYear()} All rights reserved</p>
                                </div>
                                <div className={'pull-right'}>
                                    <p>Developed & Maintain By &nbsp; <a className="footer-link" target={'_blank'} href={'https://www.vedhaslabs.com'}>Vedhas Labs</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Fragment>
        );
};

export default Footer;
